"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTypeScriptToJSON = convertTypeScriptToJSON;
function convertTypeScriptToJSON(inputString) {
    var result = {};
    // Define regex patterns to match individual properties and nested objects
    var propertyRegex = /(\w+)\??:\s*(string|number|boolean|object|\{[^}]*\}|\[[^\]]*\]|'(?:[^']|'')*'|\((?:[^()]|\([^()]*\))*\)\s*=>\s*\{[^}]*\});?/g;
    var nestedObjectRegex = /(\w+)\??:\s*\{([^}]*)\}/g;
    // Process each property and determine its type or recursively parse nested objects
    inputString.replace(propertyRegex, function (match, key, type) {
        var newKey = key; // Remove '?' by not appending it
        if (type.startsWith('{')) {
            // If it's an object type, recursively parse it
            var innerObject = type.slice(1, -1).trim();
            result[newKey] = convertTypeScriptToJSON(innerObject);
        }
        else if (type.includes("=>")) {
            // For functions, keep the function representation as a string
            result[newKey] = type;
        }
        else if (type.startsWith("'")) {
            // For union types (like 'athletics' | 'magicline'), remove quotes and keep as a string
            result[newKey] = type.replace(/\|/g, ' | ').replace(/'/g, '').trim();
        }
        else if (type.startsWith('[') || type.includes('[]')) {
            // For arrays or complex types like Studio[] or IOffering[], keep as string
            result[newKey] = type;
        }
        else {
            // For basic types, use the type as the value
            result[newKey] = type;
        }
        return match;
    });
    // Process and parse any nested object properties
    inputString.replace(nestedObjectRegex, function (match, key, innerContent) {
        var newKey = key; // Remove '?' by not appending it
        result[newKey] = convertTypeScriptToJSON(innerContent.trim());
        return match;
    });
    return result;
}
